<div class="nav-container">
    <nav class="navbar navbar-expand-lg bg-transparent">
        <div class="container-fluid d-flex justify-content-between">
            <img
            routerLink="/"
            class="navbar-brand"
            id="logo-image"
            class="logo-image"
            src="../assets/images/oa-logo-orange_lg.png"
            alt="Outdoor Access"
            style="width: 200px; cursor: pointer;"
            />
        </div>
    </nav>
</div>
<div class="postcard-container">
    <img src="https://oaprodstorage.blob.core.windows.net/public/Postcard.jpg" alt="">
    <div class="intake-container">
        <div *ngIf="!contact" class="intake-form">
            <div class="code-entry-container">
                <div class="title-container">
                  <h5>Enter your property code here</h5>
                  <ng-container *ngIf="errorMessage">
                      <div class="error-text input-msg">
                        {{ errorMessage }}
                      </div>
                  </ng-container>
                </div>
              
              <ng-container *ngIf="validationResult && validationResult.isValid">
                  <div class="success-text input-msg">Reference Code Confirmed!</div>
              </ng-container>
              
                <div class="responsive-container">
                <div class="flx-container oa-flex">
                  <div class="flx-left">
                    <input
                    #inputCodeFirst4Chars
                    id="input-codeFirst4Chars"
                    maxlength="4"
                    class="form-control code-input"
                    type="text"
                    [(ngModel)]="codeFirst4Chars"
                    (ngModelChange)="onCodeChange('input-codeFirst4Chars', $event)"
                    (paste)="onPaste($event)"
                    />
                  </div>
                  
                  <div class="flx-item flx-center">―</div>
                  
                  <div class="flx-item">
                    <input
                    #inputCodeLast4Chars
                    id="input-codeLast4Chars"
                    maxlength="4"
                    class="form-control code-input"
                    type="text"
                    [(ngModel)]="codeLast4Chars"
                    (ngModelChange)="onCodeChange('input-codeLast4Chars', $event)"
                    />
                  </div>
                </div>
                  <div class="flx-item">
                    <button
                    id="code-entry-go-button"
                    [disabled]="!validationResult || !validationResult.isValid"
                    class="btn btn-primary btn-round hvr-push el-100px"
                    (click)="onProceed()"
                    >
                    Go
                  </button>
                </div>
              
                <div *ngIf="showNoCodeButton" class="flx-item">
                  <button id="no-code-button" class="btn btn-primary btn-round hvr-push" (click)="onNoCodeClick()">I don't have a code.</button>
                </div>
                </div>
              </div>
        </div>
        <div *ngIf="contact" class="intake-offer">
            <div class="content-container">
                <p>Confirm the information below and our land managment team will use our nationwide <br> real estate database to analyze and lock-in the earning potential on your land:</p>
                <div class="info-container">
                  <div *ngIf="ownerName" class="owner-name">
                    <strong>{{ ownerName }}</strong>
                  </div>
                  <div class="info-input">
                      <div class="info-item">
                          <p>Mobile Phone Number</p>
                          <input type="tel" class="form-control" id="phoneNumber" placeholder="##########" [(ngModel)]="phoneNumber" (ngModelChange)="onPhoneNumberConfirmationChange($event)"/>
                      </div>
                      <div class="info-item">
                          <p>Email Address</p>
                          <input type="email" class="form-control" id="email" placeholder="name@email.com" [(ngModel)]="emailAddress" (ngModelChange)="onEmailConfirmationChange($event)"/>
                      </div>
                  </div>
                </div>
                <div class="activities-container">
                    <label class="oa-orange flx-left">Allowed Activities:</label>
                    <div class="responsive-container">
                      <div *ngFor="let a of activities" class="flx-container">
                        <div class="activites-item">
                          <oa-checkbox [config]="a" (stateChange)="onCheckboxStateChange($event, a)"> </oa-checkbox>
                        </div>
                      </div>
                    </div>
                    <button *ngIf="showContinue" type="button" class="btn btn-primary text-white btn-round d-inline-flex justify-content-center" routerLink="/landowner/profit">
                      Continue
                    </button>                    
                </div>                                         
            </div>
        </div>
    </div>
</div>